import { render, staticRenderFns } from "./DeliveryAddresses.vue?vue&type=template&id=4a7f3708&"
import script from "./DeliveryAddresses.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports